import React, { useState } from "react";
import {
  Box,
  VStack,
  HStack,
  Input,
  Button,
  Text,
  useColorMode,
  InputGroup,
  InputLeftElement,
  InputRightElement,
  IconButton,
  Divider,
  Link as ChakraLink,
} from "@chakra-ui/react";
import { motion } from "framer-motion";
import { FiEye, FiEyeOff, FiPhone, FiLock } from "react-icons/fi";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import Cookies from "js-cookie";
const MotionBox = motion(Box);
const MotionVStack = motion(VStack);

const Login = () => {
  const { colorMode } = useColorMode();
  const [showPassword, setShowPassword] = useState(false);
  const [formData, setFormData] = useState({
    mobile: "",
    password: "",
  });
  const navigate = useNavigate();
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    axios.post(`https://apiArmanify.zx-tm.ir/api/Users/Login?phoneNumber=${formData.mobile}&password=${formData.password}`)
      .then(res => {
        Cookies.set("User", JSON.stringify(res.data),{ expires: 1000 });
        navigate("/");
      })
      .catch(err => {
        alert("ورود با موفقیت انجام نشد");
      });
  };

  return (
    <Box
      minH="100vh"
      bg={colorMode === "dark" ? "gray.800" : "gray.50"}
      display="flex"
      alignItems="center"
      justifyContent="center"
      p={4}
    >
      <MotionBox
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        w="100%"
        maxW="400px"
      >
        <MotionVStack
          spacing={8}
          p={8}
          bg={colorMode === "dark" ? "gray.700" : "white"}
          borderRadius="xl"
          boxShadow="lg"
          border="1px solid"
          borderColor={colorMode === "dark" ? "gray.600" : "gray.200"}
        >
          {/* Header */}
          <MotionVStack
            spacing={2}
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2, duration: 0.5 }}
          >
            <Text
              fontSize="2xl"
              fontWeight="bold"
              color={colorMode === "dark" ? "white" : "gray.800"}
              textAlign="center"
            >
              ورود
            </Text>
            <Text
              fontSize="sm"
              color={colorMode === "dark" ? "gray.300" : "gray.600"}
              textAlign="center"
            >
              به حساب کاربری خود وارد شوید
            </Text>
          </MotionVStack>

          {/* Form */}
          <MotionVStack
            spacing={6}
            w="100%"
            as="form"
            onSubmit={handleSubmit}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.4, duration: 0.5 }}
          >
            {/* Mobile Number Input */}
            <VStack spacing={2} w="100%" align="start">
              <Text
                fontSize="sm"
                fontWeight="medium"
                color={colorMode === "dark" ? "gray.300" : "gray.600"}
              >
                شماره موبایل
              </Text>
              <InputGroup>
                <InputLeftElement pointerEvents="none">
                  <FiPhone color={colorMode === "dark" ? "gray.400" : "gray.500"} />
                </InputLeftElement>
                <Input
                  name="mobile"
                  value={formData.mobile}
                  onChange={handleInputChange}
                  placeholder="09123456789"
                  type="tel"
                  bg={colorMode === "dark" ? "gray.600" : "gray.50"}
                  border="1px solid"
                  borderColor={colorMode === "dark" ? "gray.500" : "gray.200"}
                  _focus={{
                    borderColor: "brand.500",
                    boxShadow: "0 0 0 1px #0ea5e9",
                  }}
                  _hover={{
                    borderColor: colorMode === "dark" ? "gray.400" : "gray.300",
                  }}
                />
              </InputGroup>
            </VStack>

            {/* Password Input */}
            <VStack spacing={2} w="100%" align="start">
              <Text
                fontSize="sm"
                fontWeight="medium"
                color={colorMode === "dark" ? "gray.300" : "gray.600"}
              >
                رمز عبور
              </Text>
              <InputGroup>
                <InputLeftElement pointerEvents="none">
                  <FiLock color={colorMode === "dark" ? "gray.400" : "gray.500"} />
                </InputLeftElement>
                <Input
                  name="password"
                  value={formData.password}
                  onChange={handleInputChange}
                  placeholder="رمز عبور خود را وارد کنید"
                  type={showPassword ? "text" : "password"}
                  bg={colorMode === "dark" ? "gray.600" : "gray.50"}
                  border="1px solid"
                  borderColor={colorMode === "dark" ? "gray.500" : "gray.200"}
                  _focus={{
                    borderColor: "brand.500",
                    boxShadow: "0 0 0 1px #0ea5e9",
                  }}
                  _hover={{
                    borderColor: colorMode === "dark" ? "gray.400" : "gray.300",
                  }}
                />
                <InputRightElement>
                  <IconButton
                    variant="ghost"
                    size="sm"
                    icon={showPassword ? <FiEyeOff /> : <FiEye />}
                    onClick={() => setShowPassword(!showPassword)}
                    aria-label={showPassword ? "Hide password" : "Show password"}
                  />
                </InputRightElement>
              </InputGroup>
            </VStack>

            {/* Login Button */}
            <Button
              type="submit"
              colorScheme="brand"
              size="lg"
              w="100%"
              borderRadius="full"
              bg="brand.500"
              _hover={{
                bg: "brand.600",
                transform: "translateY(-2px)",
                boxShadow: "0 4px 12px rgba(14, 165, 233, 0.4)",
              }}
              _active={{
                transform: "translateY(0)",
              }}
              transition="all 0.2s"
            >
              ورود
            </Button>
          </MotionVStack>

          {/* Divider */}
          <MotionBox
            w="100%"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.6, duration: 0.5 }}
          >
            <Divider />
          </MotionBox>

          {/* Register Link */}
          <MotionHStack
            spacing={2}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.8, duration: 0.5 }}
          >
            <Text
              fontSize="sm"
              color={colorMode === "dark" ? "gray.300" : "gray.600"}
            >
              حساب کاربری ندارید؟
            </Text>
            <ChakraLink
              as={Link}
              to="/register"
              color="brand.500"
              fontWeight="medium"
              _hover={{
                color: "brand.600",
                textDecoration: "underline",
              }}
            >
              ثبت نام کنید
            </ChakraLink>
          </MotionHStack>
        </MotionVStack>
      </MotionBox>
    </Box>
  );
};

const MotionHStack = motion(HStack);

export default Login;
